import React from 'react';
import { Route, Switch } from 'react-router-dom';
import routes from 'routes/routes';
import Landing from 'scenes/Landing/Landing';
import Pricing from 'scenes/Pricing/Pricing';
import Careers from 'scenes/Careers/Careers';
import WhyFlass from 'scenes/WhyFlass/WhyFlass';
import Privacy from 'scenes/Privacy/Privacy';
import Terms from 'scenes/Terms/Terms';
import DataDeletion from 'scenes/DataDeletion/DataDeletion';

const Routes = () => (
	<Switch>
		<Route path={routes.HOME} component={Landing} exact />
		<Route path={routes.PRICING} component={Pricing} exact />
		<Route path={routes.CAREERS} component={Careers} exact />
		<Route path={routes.WHY_FLASS} component={WhyFlass} exact />
		<Route path={routes.PRIVACY} component={Privacy} exact />
		<Route path={routes.TERMS} component={Terms} exact />
		<Route path={routes.DATA_DELETION} component={DataDeletion} exact />
	</Switch>
);

export default Routes;
